import { Component, OnInit } from '@angular/core';
import { ContentOptions, ContentService } from '@edassist/api';
import {
	constants,
	GeneralContentService,
	ParticipantUtilityService,
	AppConfigService,
	LocalStorageService
} from '@edassist/common';
import { map } from 'rxjs/operators';
import { BrightHorizonsLogoContent } from './bh-logo-content.interface';

@Component({
	selector: 'ea-bh-logo',
	templateUrl: './bh-logo.component.html',
	styleUrls: ['./bh-logo.component.scss']
})
export class BrightHorizonsLogoComponent implements OnInit {
	bhWebLogoContent: BrightHorizonsLogoContent;
	constants = constants;
	bhWebLogoUrl: string;

	constructor(private readonly contentService: ContentService) {}

	ngOnInit(): void {
		this.fetchBHWebLogo();
	}

	private fetchBHWebLogo(): void {
		const clientDetails = LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS) ?? {};
		if (clientDetails?.bhWebLogoPath) {
			this.bhWebLogoUrl = clientDetails.bhWebLogoPath;
		} else {
			const contentOptions: ContentOptions = {
				client: clientDetails?.clientId ?? ParticipantUtilityService.getClientLoginDetails()?.clientId?.toString(),
				textOnly: false
			};
			this.contentService
				.findByName(
					this.constants.contentConstants.contentTypes.general,
					this.constants.contentConstants.CONTENT_COMPONENTS.SITE,
					this.constants.contentConstants.CONTENT_NAMES.BH_WEB_LOGO,
					contentOptions
				)
				.pipe(map((content) => GeneralContentService.mapContent(content)))
				.subscribe((content) => {
					this.bhWebLogoContent = content;
					this.bhWebLogoUrl = this.bhWebLogoContent?.bhWebLogo.fullCdnFilePath;
					clientDetails.bhWebLogoPath = this.bhWebLogoContent?.bhWebLogo.fullCdnFilePath;
					LocalStorageService.setItem(constants.localStorageKeys.CLIENT_DETAILS, clientDetails);
				});
		}
	}
}
